<!-- <h2 ngClass="doccount"  ngClass.md="doccount-md" tabindex="0">{{ docCount | number }} documents</h2> -->

<div class="container" >
    <div class="resultItem" *ngFor="let item of results; let i = index"  id="jumpToResults-{{i}}">
      <div class="title-row-wrapper">
        <!-- <div ngClass="title" *ngIf="isGIS(item)"> <span class="title-link GIS"> {{ getTitle(item) }} </span></div> -->
        <div ngClass="title">
          <h3 class="title-link" (click)="openDocView(item)" tabindex="0" (keyup.enter)="openDocView(item)" role="link" [attr.aria-label]="getTitle(item) + ', ' + getPubTitle(item) + ' ' + getPubDate(item) + ', link opens in new tab'"> {{ getTitle(item) }} </h3>
        </div>
        <div class="title-row-pubdate"> {{ getPubDate(item) }}</div>
      </div>      
      <div [ngClass]="(results.length-1 === i && results.length > 39) ? 'citation' : 'citation border'" >{{ getPubTitle(item) }}</div>
    </div>
  </div>
  
